/** Liste araması için asgari karakter sayısı: bu sayının altında arama tetiklenmez (021). */
export const MIN_SEARCH_LEN = 2

/**
 * Sunucu sorgusuna gidecek arama terimini normalize eder: trim'ler ve **< MIN_SEARCH_LEN** ise
 * boş döndürür (arama uygulanmaz — tüm liste). Kullanıcının yazdığı ham girdi (kutu değeri) ayrıdır;
 * bu yalnız sorgu parametresini kapılar.
 */
export function searchTerm(raw: string): string {
  const s = raw.trim()
  return s.length >= MIN_SEARCH_LEN ? s : ''
}
